export const Animations = {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  confirmation: require('./animations/confirmation_basic.json'),
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  scheduledConfirmation: require('./animations/confirmation_scheduled.json'),
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  missedBus: require('./animations/missed_bus.json'),
}
